import {
  IAnalyticsDataLayerService, ISafezoneDataLayerParams, ISafezoneEventParams
} from "./analytics-data-layer.service.interface";
import {ServiceBase} from "../ServiceBase";


export class AnalyticsDataLayerService extends ServiceBase implements IAnalyticsDataLayerService{

  public pushSafezoneEvent(eventParams: ISafezoneEventParams): void {
      this._push(eventParams);
      this.services.sdk.structuredLoggingService.getLogger()
          .addCategory("SAFEZONE TRACKING")
          .addAction(eventParams.action)
          .addLabel(eventParams.correlation_id)
          .addValue(JSON.stringify(eventParams))
          .info();
  }

  public pushSafezoneInitParams() {
    let initParams:ISafezoneDataLayerParams = {
      intent: "manual", //Currently, the intent is always manual
      login_session_id: this.services.sdk.userData.sessionId,
      user_type: "member", //Currently, the user type is always member
      rm_status: this.services.user.playerRMSStatus, //change name to rm_status
      rg_risk_level: 1, //Currently, the rg risk level is always 1
      local_time: (new Date()).toString(),
      sub_brand_name: this.services.sdk.getSubBrandID(),
      sub_brand_id: this.services.sdk.getSubBrandID(),
      registration_country: this.services.user.registrationCountry,
      context: "normal", //Currently, the context is always normal
      registration_date: this.services.user.joinDate,
      cid: this.services.user.cid,
      env: this.services.sdk.getEnvironment().toLowerCase(),
      product_package: this.services.sdk.getProductPackageId()
    };
    this._push(initParams);
    this.services.sdk.structuredLoggingService.getLogger()
        .addCategory("SAFEZONE TRACKING")
        .addAction("sz_init")
        .addValue(JSON.stringify(initParams))
        .info();
  }

  private _push(params: {}):void{
    if(params){
      this.services.sdk.pushDataToDataLayer(params);
    }
  }
}
